module.exports = __webpack_public_path__ + "img/icon-terminate.fe301184.svg";